<script>
    import { TOKEN_SESSION, USER, TOAST_MESSAGE } from '../stores'
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';
    import * as Fx from '../globals/Fx'
    
    const dispatch = createEventDispatcher()
    
    onMount (async () => {

    })
    
</script>

<div class="main">
    {#if $USER}
        <div class="icon-img" on:click={TOAST_MESSAGE.set($TOAST_MESSAGE)}>
            <!-- <ion-icon name="person"></ion-icon> -->
            <span>{$USER["usu_nombre"].substr(0,1).toUpperCase()}</span>
        </div>
        <div class="label-container">
            <div>{$USER["usu_email"]}</div>
        </div>
    {:else}
        <h3>Cargando...</h3>
    {/if}
    <div class="title">
        <span>Liquidación de impuesto y Cartera </span>
    </div>
</div>

<style>
    .main {
        display: flex;
        flex-direction: row-reverse;
        right: 0px;
        top: 0px;
        color: #607d8b;
        padding: 8px;
        height: auto;
        width: 100%;
        align-items: center;
    }

    /* ion-icon {
        font-size: 1em;
        color: #fff;
    } */

    .title {
        padding: 10px 40px;
        /* width: 11em; */
        font-size: 1.1em;
        color: #ffffff;
        font-weight: 400;
        background-color: #FF5722;
        border-radius: 40px;
        margin-right: 20px;
    }

    .icon-img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5em;
        height: 2.5em;
        background-color:#e74c3c;
        border-radius: 50%;
        border: 2px solid rgb(185, 185, 185);
        color: #fff;
        cursor: pointer;
    }

    .label-container {
        display: flex;
        flex-direction: column;
        text-align: center;
        padding-right: 8px;
        justify-content: center;
    }


    @media only screen and (max-width: 640px) {
        .title  {
            display: none;
        }
    }
</style>